import { Menu, Tabs } from '@recruit-robin/robin-theme/web-components';
import { useState } from 'react';
import { useDebounce } from 'react-use';

import type { TabProps } from './Tab.types';

import { VacancyList } from 'components/ui/molecules/VacancyList/VacancyList';
import { useEnrichedVacanciesQuery } from 'hooks/reachout/useEnrichedVacanciesQuery';
import { VacancyListTab } from '../../VacancyList/VacancyList.types';
import { HighQualityJobsMessageInfo } from '../HighQualityJobsMessageInfo/HighQualityJobsMessageInfo';
import { useStyles } from './AtsTab.styles';

const AtsTabContent = ({
  onCreateJob,
  onDeleteVacancy,
  onEditVacancy,
  onSelectVacancy,
  selectedVacancy,
  search = '',
  hideMessageInfo = false,
  atsOnly = false,
}: TabProps) => {
  const classes = useStyles({ contained: false });
  const [searchDebounced, setSearchDebounced] = useState(search);
  const { data: atsVacancyList = [], isFetching } = useEnrichedVacanciesQuery({
    search: searchDebounced,
    atsOnly,
  });
  const isSearchLoading = isFetching || search !== searchDebounced;

  useDebounce(() => setSearchDebounced(search), 230, [search]);

  return (
    <>
      {!hideMessageInfo && (
        <div css={classes.messageInfo}>
          <HighQualityJobsMessageInfo />
        </div>
      )}
      {isSearchLoading ? (
        Array.from({ length: 4 }).map((_, i) => <Menu.Item.Skeleton key={i} />)
      ) : (
        <VacancyList
          onCreateJob={onCreateJob}
          selectedVacancy={selectedVacancy}
          onEditVacancy={onEditVacancy}
          onDeleteVacancy={onDeleteVacancy}
          onSelectVacancy={onSelectVacancy}
          vacanciesList={atsVacancyList}
        />
      )}
    </>
  );
};

export const AtsTab = (props: TabProps) => {
  const classes = useStyles({ contained: false });

  return (
    <Tabs.Content customCss={classes.tabsContent} value={VacancyListTab.AtsJobs}>
      <AtsTabContent {...props} />
    </Tabs.Content>
  );
};
